import React from "react";
import { Create, translate } from "react-admin";
import SaleAgencyForm from "./SaleAgencyForm";

const SaleAgencyTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("saleagency.saleagency")}`}</span>;
};

const Title = translate(SaleAgencyTitle);

export const SaleAgencyCreate = props => (
  <Create title={<Title />} {...props}>
    <SaleAgencyForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/saleagency/SaleAgencyCreate.js